import { ConditionalOperator as t } from "../../../../node_modules/gridify-client/dist/index.esm.js";
import { isLastValue as o } from "./utils/isLastValue.js";
import { isStringArray as i } from "./utils/isStringArray.js";
import { sanitizeUserInput as r } from "./utils/sanitizeUserInput.js";
const s = (t2) => "textSearch" === t2.type, n = (s2, n2) => {
  const { key: e, op: a, value: d } = s2, p = r(d), m = a ? t[a] : t.Contains, u = i(e);
  return u && n2.startGroup(), u ? e.forEach((t2, i2) => {
    n2.addCondition(t2, m, p, false), o(e, i2) || n2.or();
  }) : n2.addCondition(e, m, p, false), u && n2.endGroup(), n2;
};
export {
  s as isTextSearch,
  n as serializeTextSearch
};
//# sourceMappingURL=serializeTextSearch.js.map
